module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"copyrights":"Four Seasons - All rights reserved.","created-by":"This website developed by Aavani Info Team - ","links":"Navigation:","contact":{"subheader":"Contact us via:","email":"Email Address","address":"Address","website":"Website"}}}')
  delete Component.options._Ctor
}
